import {connect} from "react-redux";
import React,{useState} from "react";
import Icon from "@mdi/react";
import {mdiClose} from "@mdi/js";
import Style from "./UEModal.scss";

const UEAdminModal = ({children, title, onClose, show})=>{

    if(!show) return null;


    return(<div id={"ue-admin-modal1-wrapper"} className={"ue-admin-modal1-wrapper "} >
            <div id={'ue-admin-modal1'} className={(show)?'ue-admin-modal1 d-flex flex-column h-100 w-100 show':''} >
                <div className={" w-100 h-100 p-2"}>
                    <div className={"d-flex flex-row justify-content-between align-items-center mb-2"}>
                        <div className={"h3 w-100 text-left ue-admin-modal-title"}>{title}</div>
                        <div className={'ue-admin-modal-btn-icon-sm'} onClick={onClose}>
                            <Icon className={"mx-2"} path={mdiClose} size={0.8} color={"var(--theme_primary)"} />
                        </div>
                    </div>
                    <div className={"d-flex flex-column justify-content-start align-items-center ue-admin-modal1-body w-100 h-100"} >
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UEAdminModal
